<template>
  <v-card class="credits-overview-dialog" flat>
    <div v-if="is_mobile" class="d-flex mt-n4 mr-n4">
      <v-btn
        icon
        dark
        variant="text"
        class="ml-auto"
        @click="$emit('close-dialog')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-btn
      v-if="!is_mobile"
      icon
      dark
      variant="text"
      class="dialog-close-btn"
      @click="$emit('close-dialog')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <div class="d-flex flex-column ga-8">
      <div class="">
        <h1>{{ $t("jouw-creditoverzicht") }}</h1>
        <p class="mt-2">
          {{
            $t(
              "bekijk-hier-hoeveel-credits-je-al-hebt-gebruikt-en-wat-je-nog-over-hebt"
            )
          }}
        </p>
      </div>

      <component :is="currentPeriodComponent" :max="max" />

      <!-- Activiteiten met een eigen tegoed (86c6gv8yw): dat gaat niet van de
           credits hierboven af, dus elk krijgt zijn eigen regel. -->
      <div v-if="activityCredits.length" class="d-flex flex-column ga-4">
        <p class="text-bold">{{ $t("activity_credits.heading") }}</p>
        <div v-for="line in activityCredits" :key="line.activity">
          <div class="d-flex align-center justify-space-between ga-4">
            <p class="text-bold">{{ line.title }}</p>
            <p class="text-no-wrap">
              {{
                $t("activity_credits.left", {
                  left: line.left,
                  max: line.max,
                  period: $t(`activity_credits.period.${line.period}`),
                })
              }}
            </p>
          </div>
          <v-progress-linear
            class="rounded-sm"
            :max="line.max || 1"
            :model-value="line.used"
            color="var(--company-primary)"
          ></v-progress-linear>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import DailyOverview from "./credit-overviews/daily-overview.vue";
import WeeklyOverview from "./credit-overviews/weekly-overview.vue";
import MonthlyOverview from "./credit-overviews/monthly-overview.vue";
import YearlyOverview from "./credit-overviews/yearly-overview.vue";

import { useMainStore } from "../../stores/store";
import isMobile from "@/mixins/isMobile";
import CreditsService from "@/services/CreditsService";
import { activityCreditLine } from "@/util/activityCredits";

export default {
  mixins: [isMobile],
  components: {
    DailyOverview,
    WeeklyOverview,
    MonthlyOverview,
    YearlyOverview,
  },
  data() {
    return {
      max: 0,
      period: null,
      activityCredits: [],
      mainStore: useMainStore(),
    };
  },

  mounted() {
    this.period = this.mainStore.companypage.settings.period;
    this.max = this.mainStore.companypage.settings.credits;
    this.getActivityCredits();
  },

  methods: {
    getActivityCredits() {
      const nl = this.$i18n.locale === "nl";
      CreditsService.getActivityCredits()
        .then((res) => {
          this.activityCredits = (res.data.data || []).map((line) => ({
            activity: line.activity,
            title: (nl ? line.title?.nl : line.title?.en) || line.title?.nl || "",
            ...activityCreditLine(line),
          }));
        })
        .catch(() => {
          this.activityCredits = [];
        });
    },
  },

  computed: {
    currentPeriodComponent() {
      switch (this.period) {
        case "day":
          return DailyOverview;
        case "week":
          return WeeklyOverview;
        case "month":
          return MonthlyOverview;
        case "year":
          return YearlyOverview;
        default:
          // dont return anything if no period is set
          return null;
      }
    },
  },
};
</script>
